import { TeceoApiResponse, default as createRepository } from '../../lib/basicRepository';
import { restApi } from '../../services/api';
import { User } from '../user-admin/user.types';

export const brandGeneralSettingsRepository = () =>
  createRepository({
    path: `brands/general-settings`,
    restApi,
  });

export const brandRepository = () =>
  createRepository({
    path: `brands`,
    restApi,
  });

export const brandAddressRepository = (id: string) =>
  createRepository({
    path: `brands/address`,
    id,
    restApi,
  });

export const getBrandUsers = async (brandId: string, query?: string) => {
  const params = new URLSearchParams();
  params.append('brandId', brandId);
  params.append('query', query ?? '');

  return restApi.get<TeceoApiResponse<User[]>>('brands/users', params);
};
